// Tool results the model reads that the app also reads back. The wording and
// its parsing live together here, so changing one cannot silently break the
// other (the tests check the round trip).

/** The `say` tool's result: said in the chat only, or also placed on the board. */
export function sayResult(placed?: { messageId: string; under?: string | undefined }): string {
  if (!placed) return 'said'
  const under = placed.under ? ` under ${placed.under}` : ''
  return `said, and placed on the board as message ${placed.messageId}${under}`
}

/** The board message a `say` result says it placed, if any (notes may follow on later lines). */
export function placedMessageId(result: string): string | null {
  return (
    /^said, and placed on the board as message (\S+?)(?: under \S+)?(?:\n|$)/.exec(result)?.[1] ??
    null
  )
}

/**
 * The result of a `say` that was not delivered because a board change in the
 * same step failed (DESIGN.md: a reply never claims what didn't happen). The
 * chat leaves such a `say` out; the model is told to look and speak again.
 */
export const WITHHELD_SAY =
  'Not delivered: a board change in this same step failed (see its result), so this message could claim something that did not happen. Look at the results, then tell the person what actually happened in a new step.'
